import { Component } from '@angular/core';

@Component({
    selector: 'app-privacy',
    standalone: true,
    templateUrl: './privacy.component.html',
    styleUrl: './privacy.component.css'
})
export class PrivacyComponent { }
